// extracted by mini-css-extract-plugin
export default {"advertDetailContactGroup":"c-k_gW","advertDetailContactGroup__header":"c-k_gX","advertDetailContactGroup__value":"c-k_gY"};